/**
 * Инициализация Telegram Web App API
 * Этот файл должен быть подключен в HTML до загрузки основного приложения
 */

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        downloadFile: (params: { url: string; file_name: string }) => void;
        ready: () => void;
        expand: () => void;
        close: () => void;
        isExpanded: boolean;
        openLink?: (url: string) => void;
        showAlert?: (message: string) => void;
        initDataUnsafe?: {
          user?: {
            id: number;
            first_name: string;
            last_name?: string;
            username?: string;
            language_code?: string;
          };
          query_id?: string;
          auth_date?: number;
          hash?: string;
        };
        initData?: string;
        colorScheme: 'light' | 'dark';
        themeParams: {
          bg_color?: string;
          text_color?: string;
          hint_color?: string;
          link_color?: string;
          button_color?: string;
          button_text_color?: string;
        };
        isClosingConfirmationEnabled: boolean;
        headerColor: string;
        backgroundColor: string;
        BackButton: {
          isVisible: boolean;
          onClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
        };
        MainButton: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isProgressVisible: boolean;
          isActive: boolean;
          onClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
          enable: () => void;
          disable: () => void;
          showProgress: (leaveActive?: boolean) => void;
          hideProgress: () => void;
          setText: (text: string) => void;
          setParams: (params: {
            text?: string;
            color?: string;
            text_color?: string;
            is_visible?: boolean;
            is_progress_visible?: boolean;
            is_active?: boolean;
          }) => void;
        };
        HapticFeedback: {
          impactOccurred: (
            style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
          ) => void;
          notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
          selectionChanged: () => void;
        };
        CloudStorage: {
          getItem: (key: string) => Promise<string | null>;
          setItem: (key: string, value: string) => Promise<void>;
          removeItem: (key: string) => Promise<void>;
          getKeys: () => Promise<string[]>;
        };
        BiometricManager: {
          isInited: boolean;
          isSupported: boolean;
          isBiometricAvailable: boolean;
          isLSAvailable: boolean;
          isDeviceSecure: boolean;
          requestAccess: (reason?: string) => Promise<boolean>;
          authenticate: (reason?: string) => Promise<boolean>;
        };
        Popup: {
          open: (params: {
            title?: string;
            message: string;
            buttons?: Array<{
              id?: string;
              type?: 'default' | 'ok' | 'close' | 'cancel' | 'destructive';
              text: string;
            }>;
          }) => Promise<string | undefined>;
          close: () => void;
        };
        PopupParams: {
          title?: string;
          message: string;
          buttons?: Array<{
            id?: string;
            type?: 'default' | 'ok' | 'close' | 'cancel' | 'destructive';
            text: string;
          }>;
        };
        QrPopup: {
          open: (params: { text: string }) => Promise<string | undefined>;
          close: () => void;
        };
        QrPopupParams: {
          text: string;
        };
        ScanQrPopup: {
          open: (params: { text?: string }) => Promise<string | undefined>;
          close: () => void;
        };
        ScanQrPopupParams: {
          text?: string;
        };
        Invoice: {
          open: (params: {
            title: string;
            description: string;
            payload: string;
            provider_token: string;
            currency: string;
            prices: Array<{
              label: string;
              amount: number;
            }>;
            max_tip_amount?: number;
            suggested_tip_amounts?: number[];
            start_parameter?: string;
            photo_url?: string;
            photo_size?: number;
            photo_width?: number;
            photo_height?: number;
            need_name?: boolean;
            need_phone_number?: boolean;
            need_email?: boolean;
            need_shipping_address?: boolean;
            send_phone_number_to_provider?: boolean;
            send_email_to_provider?: boolean;
            is_flexible?: boolean;
          }) => Promise<string | undefined>;
          close: () => void;
        };
        InvoiceParams: {
          title: string;
          description: string;
          payload: string;
          provider_token: string;
          currency: string;
          prices: Array<{
            label: string;
            amount: number;
          }>;
          max_tip_amount?: number;
          suggested_tip_amounts?: number[];
          start_parameter?: string;
          photo_url?: string;
          photo_size?: number;
          photo_width?: number;
          photo_height?: number;
          need_name?: boolean;
          need_phone_number?: boolean;
          need_email?: boolean;
          need_shipping_address?: boolean;
          send_phone_number_to_provider?: boolean;
          send_email_to_provider?: boolean;
          is_flexible?: boolean;
        };
        SettingsButton: {
          isVisible: boolean;
          onClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
        };
        ThemeParams: {
          bg_color?: string;
          text_color?: string;
          hint_color?: string;
          link_color?: string;
          button_color?: string;
          button_text_color?: string;
        };
        Viewport: {
          isExpanded: boolean;
          height: number;
          isStateStable: boolean;
          stableHeight: number;
          expand: () => void;
          close: () => void;
        };
        WebApp: {
          ready: () => void;
          expand: () => void;
          close: () => void;
          isExpanded: boolean;
          openLink?: (url: string) => void;
          showAlert?: (message: string) => void;
          initDataUnsafe?: {
            user?: {
              id: number;
              first_name: string;
              last_name?: string;
              username?: string;
              language_code?: string;
            };
            query_id?: string;
            auth_date?: number;
            hash?: string;
          };
          initData?: string;
          colorScheme: 'light' | 'dark';
          themeParams: {
            bg_color?: string;
            text_color?: string;
            hint_color?: string;
            link_color?: string;
            button_color?: string;
            button_text_color?: string;
          };
          isClosingConfirmationEnabled: boolean;
          headerColor: string;
          backgroundColor: string;
          BackButton: {
            isVisible: boolean;
            onClick: (callback: () => void) => void;
            show: () => void;
            hide: () => void;
          };
          MainButton: {
            text: string;
            color: string;
            textColor: string;
            isVisible: boolean;
            isProgressVisible: boolean;
            isActive: boolean;
            onClick: (callback: () => void) => void;
            show: () => void;
            hide: () => void;
            enable: () => void;
            disable: () => void;
            showProgress: (leaveActive?: boolean) => void;
            hideProgress: () => void;
            setText: (text: string) => void;
            setParams: (params: {
              text?: string;
              color?: string;
              text_color?: string;
              is_visible?: boolean;
              is_progress_visible?: boolean;
              is_active?: boolean;
            }) => void;
          };
          HapticFeedback: {
            impactOccurred: (
              style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'
            ) => void;
            notificationOccurred: (
              type: 'error' | 'success' | 'warning'
            ) => void;
            selectionChanged: () => void;
          };
          CloudStorage: {
            getItem: (key: string) => Promise<string | null>;
            setItem: (key: string, value: string) => Promise<void>;
            removeItem: (key: string) => Promise<void>;
            getKeys: () => Promise<string[]>;
          };
          BiometricManager: {
            isInited: boolean;
            isSupported: boolean;
            isBiometricAvailable: boolean;
            isLSAvailable: boolean;
            isDeviceSecure: boolean;
            requestAccess: (reason?: string) => Promise<boolean>;
            authenticate: (reason?: string) => Promise<boolean>;
          };
          Popup: {
            open: (params: {
              title?: string;
              message: string;
              buttons?: Array<{
                id?: string;
                type?: 'default' | 'ok' | 'close' | 'cancel' | 'destructive';
                text: string;
              }>;
            }) => Promise<string | undefined>;
            close: () => void;
          };
          PopupParams: {
            title?: string;
            message: string;
            buttons?: Array<{
              id?: string;
              type?: 'default' | 'ok' | 'close' | 'cancel' | 'destructive';
              text: string;
            }>;
          };
          QrPopup: {
            open: (params: { text: string }) => Promise<string | undefined>;
            close: () => void;
          };
          QrPopupParams: {
            text: string;
          };
          ScanQrPopup: {
            open: (params: { text?: string }) => Promise<string | undefined>;
            close: () => void;
          };
          ScanQrPopupParams: {
            text?: string;
          };
          Invoice: {
            open: (params: {
              title: string;
              description: string;
              payload: string;
              provider_token: string;
              currency: string;
              prices: Array<{
                label: string;
                amount: number;
              }>;
              max_tip_amount?: number;
              suggested_tip_amounts?: number[];
              start_parameter?: string;
              photo_url?: string;
              photo_size?: number;
              photo_width?: number;
              photo_height?: number;
              need_name?: boolean;
              need_phone_number?: boolean;
              need_email?: boolean;
              need_shipping_address?: boolean;
              send_phone_number_to_provider?: boolean;
              send_email_to_provider?: boolean;
              is_flexible?: boolean;
            }) => Promise<string | undefined>;
            close: () => void;
          };
          InvoiceParams: {
            title: string;
            description: string;
            payload: string;
            provider_token: string;
            currency: string;
            prices: Array<{
              label: string;
              amount: number;
            }>;
            max_tip_amount?: number;
            suggested_tip_amounts?: number[];
            start_parameter?: string;
            photo_url?: string;
            photo_size?: number;
            photo_width?: number;
            photo_height?: number;
            need_name?: boolean;
            need_phone_number?: boolean;
            need_email?: boolean;
            need_shipping_address?: boolean;
            send_phone_number_to_provider?: boolean;
            send_email_to_provider?: boolean;
            is_flexible?: boolean;
          };
          SettingsButton: {
            isVisible: boolean;
            onClick: (callback: () => void) => void;
            show: () => void;
            hide: () => void;
          };
          ThemeParams: {
            bg_color?: string;
            text_color?: string;
            hint_color?: string;
            link_color?: string;
            button_color?: string;
            button_text_color?: string;
          };
          Viewport: {
            isExpanded: boolean;
            height: number;
            isStateStable: boolean;
            stableHeight: number;
            expand: () => void;
            close: () => void;
          };
        };
      };
    };
  }
}

/**
 * Инициализация Telegram Web App
 * Должна вызываться при загрузке приложения
 */
export const initTelegramWebApp = (): void => {
  // Проверяем, что мы в Telegram Web App
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    try {
      // Готовим Web App к использованию
      window.Telegram.WebApp.ready();

      // Расширяем Web App на весь экран
      window.Telegram.WebApp.expand();

      console.log('Telegram Web App инициализирован успешно');
      console.log('Пользователь:', window.Telegram.WebApp.initDataUnsafe?.user);

      // Устанавливаем цветовую схему
      document.documentElement.setAttribute(
        'data-theme',
        window.Telegram.WebApp.colorScheme
      );

      // Применяем цвета темы
      if (window.Telegram.WebApp.themeParams) {
        const root = document.documentElement;
        const theme = window.Telegram.WebApp.themeParams;

        if (theme.bg_color) {
          root.style.setProperty('--tg-theme-bg-color', theme.bg_color);
        }
        if (theme.text_color) {
          root.style.setProperty('--tg-theme-text-color', theme.text_color);
        }
        if (theme.hint_color) {
          root.style.setProperty('--tg-theme-hint-color', theme.hint_color);
        }
        if (theme.link_color) {
          root.style.setProperty('--tg-theme-link-color', theme.link_color);
        }
        if (theme.button_color) {
          root.style.setProperty('--tg-theme-button-color', theme.button_color);
        }
        if (theme.button_text_color) {
          root.style.setProperty(
            '--tg-theme-button-text-color',
            theme.button_text_color
          );
        }
      }
    } catch (error) {
      console.error('Ошибка при инициализации Telegram Web App:', error);
    }
  } else {
    console.log('Telegram Web App API недоступен');
  }
};

/**
 * Проверка, запущено ли приложение в Telegram
 */
export const isTelegramWebApp = (): boolean => {
  return typeof window !== 'undefined' && !!window.Telegram?.WebApp;
};

/**
 * Получение данных пользователя из Telegram Web App
 */
export const getTelegramUser = () => {
  if (isTelegramWebApp()) {
    return window.Telegram?.WebApp?.initDataUnsafe?.user;
  }
  return null;
};
